<template>
  <div>
    <v-toolbar dense>
      <v-btn flat icon @click="onCancel">
        <v-icon>close</v-icon>
      </v-btn>
      <div class="text-lg-left text-capitalize beez-bold ml-2">
        Create Service from {{ this.isWorkflow ? 'Workflow' : 'Bot' }}
      </div>
      <v-spacer></v-spacer>
      <!-- Todo: Icon for SelfService Pending -->
      <v-btn
        flat
        :class="!$vuetify.dark ? 'secondary' : ''"
        :outline="$vuetify.dark"
        class="secondary text-capitalize mr-1"
        @click="createSelfService"
      >
        Create Service
      </v-btn>
    </v-toolbar>
    <v-card style="padding-top: 50px !important;">
      <v-layout row wrap class="beez-padding">
        <!--          <v-flex d-flex xs12>-->
        <!--            <v-label>Choose the User language</v-label>-->
        <!--            <v-select v-model="languageList" @select="languageChange()"></v-select>-->
        <!--          </v-flex>-->
        <v-flex xs12>
          <v-container>
            <div class="text-xs-left pb-3">
              <div class="body-1">
                Selected {{ isWorkflow ? 'Workflow' : 'Bot' }}
              </div>
            </div>
            <v-card style="border-radius: 5px" class="pa-3" color="secondary">
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="text-xs-left">
                    <!-- <v-text-field
                      value="
                      isWorkflow ? item.workflow.name : item.bot.name"
                      disabled
                      solo
                    ></v-text-field> -->
                    <div class="subheading" color="primary">
                      {{ isWorkflow ? item.workflow.name : item.bot.name }}
                    </div>
                    <div class="body-2">
                      {{
                        isWorkflow
                          ? item.workflow.description
                          : item.bot.description
                      }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
        </v-flex>
        <v-flex class="pa-3" d-flex xs12>
          <v-text-field
            color="secondary"
            v-model="item.name"
            label="Service Name"
          ></v-text-field>
        </v-flex>
        <v-flex class="pa-3" d-flex xs12>
          <v-text-field
            color="secondary"
            v-model="item.description"
            label="Service Description"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import u from '@/utils'
import moment from 'moment'
import marked from 'marked'
import EditableListView from '../common/EditableListView'
import ProposalRenderer from '../common/ProposalRenderer'

export default {
  name: 'SelfServiceModeler',
  components: {
    EditableListView,
    ProposalRenderer
  },
  props: {
    selectedItem: {
      type: Object,
      required: true
    },
    isWorkflow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      item: {},
      allProfiles: [],
      languageList: [],
      showDocumentation: true,
      showProposal: false,
      documentation: '',
      compiledMD: ''
    }
  },
  watch: {
    documentation() {
      this.compiledMD = marked(this.documentation)
    }
  },
  created() {
    this.initServiceItem()
  },
  mounted() {
    this.initServiceItem()
  },
  methods: {
    // languageChange(lang) {
    //     this.item.userTexts.forEach(o => {
    //     })
    // },
    onCancel() {
      this.$emit('cancel')
    },
    initServiceItem() {
      let selectedItemClone = u.clone(this.selectedItem)

      if (this.isWorkflow) {
        this.item.bot = null
        this.item.workflow = selectedItemClone
        this.item.name = selectedItemClone.name
        this.item.description = selectedItemClone.description
      } else {
        this.item.workflow = null
        this.item.bot = selectedItemClone
        this.item.name = selectedItemClone.name
        this.item.description = selectedItemClone.description
      }
      this.item.profiles = selectedItemClone.profiles
      this.item.proposals = selectedItemClone.proposals
      this.item.documentation = ''
    },

    async createSelfService() {
      this.item.documentation = this.documentation
      try {
        await this.$store.dispatch('saveSelfService', this.item)
        this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Automation Service created Successfully',
          description:
            'The ' + this.isWorkflow
              ? 'Workflow'
              : 'Bot' +
                ' has been created as a Self-Service with name ' +
                this.item.name,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to create Automation Service',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped></style>
